import React, { useEffect } from 'react';
import styled from 'styled-components';
import Rate from 'rc-rate';
import { useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';
import { StarStyles } from '../../../../../../styles/theme/default/others';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .star-container {
    text-align: center;
    display: flex;
    align-items: center;
  }
  .total-reviews {
    margin-left: 10px;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;

    font-weight: normal;
    font-size: 14px;
    font-weight: normal;
    line-height: 23px;

    color: #6c6c6c;
  }
`;

function StarsInfo({ productData }) {
  const location = useLocation();
  const scrollToReviews = () => {
    scroller.scrollTo('reviews-place', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: -50
    });
  };

  useEffect(() => {
    if (location.pathname.endsWith('/review')) {
      scroller.scrollTo('reviews-place', {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: 200
      });
    }
  }, []);

  return (
    <Wrapper onClick={scrollToReviews}>
      {productData.frame.subcategories[0].avg_rating ? (
        <div
          className="star-container"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            // scrollToReviews();
          }}
        >
          <StarStyles>
            <Rate
              value={parseFloat(
                productData.frame.subcategories[0].avg_rating / 2
              )}
              style={{ fontSize: 16 }}
              allowClear={false}
              disabled={true}
              allowHalf
              character={<i className="icon-star-rating" />}
            />
          </StarStyles>
          <div className="total-reviews">
            {productData.frame.subcategories[0].total_reviews} Reviews
          </div>
        </div>
      ) : (
        ''
      )}
    </Wrapper>
  );
}

export default StarsInfo;
